import { checkoutFinishData } from './checkout-finish-data.js';
import { fetchExtraProductOfferInfo } from "./fetch-extra-product-offer-info.js";
import { BRAND_NAME } from "./meta";

/**
 * @typedef {Object} ConfirmationProductsData
 * @property {string} productId
 * @property {string} name
 * @property {string} price
 * @property {string} quantity
 */

/**
 * @param {OrderData} order
 * @param {ConfirmationProductsData} storeItems
 * @returns {*}
 */
export function createCheckoutConfirmationPage(order, storeItems) {
  return fetchExtraProductOfferInfo(storeItems.map((item) => item.productId))
    .then((itemExtraInfo) => {
      return itemExtraInfo.reduce((accumulator, extraInfo) => {
        return accumulator.set(extraInfo.id, extraInfo);
      }, new Map())
    })
    .then((/** Map.<string, ProductExtraInfo>> */itemExtraInfoMap) => {
      return checkoutFinishData(order, storeItems.map((item) => ({
        'id': itemExtraInfoMap.get(item.productId).elementXmlId,
        'name': item.name,
        'price': item.price,
        'brand': BRAND_NAME,
        'catID': itemExtraInfoMap.get(item.productId).elementSectionId,
        'catName': itemExtraInfoMap.get(item.productId).elementSectionName,
        'category': itemExtraInfoMap.get(item.productId).elementSectionPath,
        'categoryId': itemExtraInfoMap.get(item.productId).elementSectionId,
        'variant': itemExtraInfoMap.get(item.productId).size,
        'quantity': item.quantity,
        'count': item.quantity,
      })))
    });
}
